export function template(tpl: string, data: Record<string, string | number>) {
    let inVariable = false;
    let eles: string[] = [];
    let prePos = 0;
    let prePrePos = 0;
    for (;;) {
        if (inVariable) {
            const pos = tpl.indexOf('}}', prePos);
            if (pos > -1) {
                inVariable = false;
                const varName = tpl.slice(prePos, pos);
                eles.push(tpl.slice(prePrePos, prePos - 2));
                eles.push(data[varName]?.toString() || `{{${varName}}}`);
                prePos = pos + 2;
            } else {
                eles.push(tpl.slice(prePrePos, prePos));
                eles.push(tpl.slice(prePos));
                break;
            }
        } else {
            const pos = tpl.indexOf('{{', prePos);
            if (pos > -1) {
                inVariable = true;
                prePrePos = prePos;
                prePos = pos + 2;
            } else {
                eles.push(tpl.slice(prePos));
                break;
            }
        }
    }
    return eles.join('');
}
